import { render, staticRenderFns } from "./MusicSystem.vue?vue&type=template&id=a9cd5c32&scoped=true&"
import script from "./MusicSystem.vue?vue&type=script&lang=ts&"
export * from "./MusicSystem.vue?vue&type=script&lang=ts&"
import style0 from "./MusicSystem.vue?vue&type=style&index=0&id=a9cd5c32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cd5c32",
  null
  
)

export default component.exports